<template>
  <div>
    <el-dialog title="修改课程信息" :visible.sync="openCardDialog">
      <el-form :model="form" label-width="45%">
        <el-form-item label="ID">
          <el-col :span="6">
            <el-input v-model="form.id" :disabled="true"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="标题">
          <el-col :span="6">
            <el-input v-model="form.title" :disabled="true"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="简介">
          <el-col :span="6">
            <el-input v-model="form.info"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="学时">
          <el-col :span="6">
            <el-input v-model="form.hour"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="价格（元）">
          <el-col :span="6">
            <el-input v-model="form.price"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="类型">
          <div style="float: left">
            <el-select v-model="form.type" placeholder="请选择">
              <el-option
                  v-for="item in options"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item>
          <el-col :span="6">
            <el-button type="primary" @click="save()">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {Message} from "element-ui";

export default {
  name: "UpCourseDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    form: ''
  },
  computed: {
    openCardDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val) // openCardDialog改变的时候通知父组件
      }
    }
  },
  data() {
    return {
      options: ''
    }
  },
  watch: {
    form: function (newVal, oldVal) {
      this.form = newVal;  //newVal即是uid

    }
  },
  created() {
    this.getCategory()
  },
  methods: {
    // 获取课程类别
    async getCategory() {
      const {data: res} = await this.$http.get("/category")
      this.options = res.data
    },
    save() {
      this.$http.post('/courses/update', this.form).then(res => {
        if (res.data.code === 1) {
          Message.success('修改成功');
        } else {
          Message.error('修改失败');
        }
        setTimeout(()=>{
          location.reload()
        },300)
      })
    }
  }
}
</script>

<style scoped>

</style>
